module.exports = __webpack_public_path__ + "img/icon-dropdown.38e76d9c.svg";